import { getAllSnippets, getUnreadEmailsCount } from '@/services/inbox.service';
import { NotificationManager } from 'react-notifications';

import {
  SET_ALL_EMAILS_SELECTED_CAMPAIGNS,
  SET_ALL_EMAILS_SELECTED_READ_STATUS,
  SET_ALL_EMAILS_SELECTED_STAGE,
  SET_ALL_EMAILS_SELECTED_TAG,
  SET_ALL_SNIPPETS,
  SET_DATE_RANGE,
  SET_SELECTED_INBOX,
  SET_UNREAD_EMAILS_COUNT,
} from './inboxType';

export const _setAllEmailsSelectedCampaigns = (data) => async (dispatch, state) => {
  if (typeof data === 'function') {
    dispatch({ type: SET_ALL_EMAILS_SELECTED_CAMPAIGNS, payload: data(state) });
    return;
  }
  dispatch({ type: SET_ALL_EMAILS_SELECTED_CAMPAIGNS, payload: data });
};

export const _setAllEmailsSelectedStage = (data) => (dispatch, state) => {
  if (typeof data === 'function') {
    dispatch({ type: SET_ALL_EMAILS_SELECTED_STAGE, payload: data(state) });
    return;
  }
  dispatch({ type: SET_ALL_EMAILS_SELECTED_STAGE, payload: data });
};

export const _setAllEmailsSelectedTag = (data) => (dispatch, state) => {
  if (typeof data === 'function') {
    dispatch({ type: SET_ALL_EMAILS_SELECTED_TAG, payload: data(state) });
    return;
  }
  dispatch({ type: SET_ALL_EMAILS_SELECTED_TAG, payload: data });
};

export const _setAllEmailsSelectedReadStatus = (data) => (dispatch, state) => {
  dispatch({ type: SET_ALL_EMAILS_SELECTED_READ_STATUS, payload: data });
};

export const _setDateRange = (data) => (dispatch, state) => {
  if (typeof data === 'function') {
    dispatch({ type: SET_DATE_RANGE, payload: data(state) });
    return;
  }
  dispatch({ type: SET_DATE_RANGE, payload: data });
};

export const _setSelectedInbox = (data) => (dispatch, state) => {
  if (typeof data === 'function') {
    dispatch({ type: SET_SELECTED_INBOX, payload: data(state) });
    return;
  }
  dispatch({ type: SET_SELECTED_INBOX, payload: data });
};

export const fetchAllSnippets = () => async (dispatch) => {
  const response = await getAllSnippets();

  if (response.status) {
    dispatch({ type: SET_ALL_SNIPPETS, payload: response.data });
  } else {
    NotificationManager.error(response.data?.message || 'Something went wrong');
  }
};

export const fetchInboxUnreadEmailsCount = () => async (dispatch) => {
  const response = await getUnreadEmailsCount();
  dispatch({ type: SET_UNREAD_EMAILS_COUNT, payload: response.data.unreadCount });
};
